var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84377 0.366524H16.6937L8.5447 25.44C8.46095 25.6976 8.3015 25.9215 8.08879 26.0801C7.87608 26.2387 7.62084 26.324 7.35898 26.3241H1.24978C1.05138 26.3241 0.855823 26.2751 0.679291 26.181C0.502759 26.087 0.350325 25.9507 0.234599 25.7833C0.118874 25.616 0.0431837 25.4224 0.0137902 25.2186C-0.0156033 25.0149 0.00214509 24.8068 0.0655667 24.6116L7.65775 1.25065C7.74147 0.992899 7.90094 0.768913 8.11371 0.610246C8.32648 0.451579 8.58182 0.366226 8.84377 0.366211V0.366524Z",
    fill: "url(#paint0_linear_3167_1192)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2515 17.1838H7.80333C7.6876 17.1837 7.57451 17.2198 7.4788 17.2873C7.38309 17.3549 7.3092 17.4508 7.26674 17.5626C7.22428 17.6744 7.21523 17.7969 7.24076 17.9141C7.2663 18.0314 7.32523 18.1379 7.4099 18.2198L15.4088 25.9729C15.6417 26.1985 15.9483 26.3239 16.2668 26.3238H23.3154L20.2515 17.1838Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84511 0.367197C8.5803 0.366142 8.3221 0.453042 8.10824 0.615204C7.89437 0.777367 7.73604 1.00629 7.65637 1.26855L0.0762459 24.5909C0.0085574 24.7869 -0.0126932 24.9969 0.0142917 25.2031C0.0412766 25.4094 0.115703 25.6059 0.231276 25.7759C0.346848 25.946 0.500166 26.0847 0.678259 26.1802C0.856353 26.2758 1.05398 26.3253 1.25443 26.3248H7.5213C7.75471 26.2815 7.97286 26.1746 8.15348 26.0151C8.3341 25.8556 8.47071 25.6491 8.54935 25.4168L10.061 20.7905L15.4605 26.0205C15.6868 26.2148 15.9706 26.3223 16.2642 26.3248H23.2866L20.2067 17.1848L11.2283 17.187L16.7234 0.367197H8.84511Z",
    fill: "url(#paint1_linear_3167_1192)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8704 1.24909C18.7868 0.991751 18.6275 0.768135 18.4151 0.609746C18.2026 0.451358 17.9477 0.366179 17.6862 0.366211H8.9375C9.19902 0.366226 9.45394 0.451423 9.66638 0.609805C9.87882 0.768187 10.0381 0.991776 10.1217 1.24909L17.7142 24.6109C17.7777 24.8062 17.7955 25.0143 17.7661 25.2181C17.7367 25.422 17.661 25.6156 17.5453 25.783C17.4296 25.9504 17.2771 26.0868 17.1006 26.1809C16.924 26.275 16.7284 26.3241 16.53 26.3241H25.2789C25.4774 26.324 25.6729 26.2749 25.8494 26.1808C26.026 26.0867 26.1784 25.9503 26.2941 25.7829C26.4098 25.6155 26.4854 25.4219 26.5148 25.2181C26.5441 25.0143 26.5263 24.8062 26.4629 24.6109L18.8704 1.24909Z",
    fill: "url(#paint2_linear_3167_1192)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3167_1192",
    x1: 11.7048,
    y1: 2.29007,
    x2: 2.98353,
    y2: 27.1006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3167_1192",
    x1: 14.2528,
    y1: 13.9463,
    x2: 12.3528,
    y2: 14.5649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3167_1192",
    x1: 13.2146,
    y1: 1.56029,
    x2: 22.7726,
    y2: 26.0813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureIcon);
export default __webpack_public_path__ + "static/media/azure-icon.b44fb108ff90b09642066738af63a9fb.svg";
export { ForwardRef as ReactComponent };